import { z } from 'zod'

export const DatabusSourceSystemSchema = z.union([
  z.literal('SoftPoint'),
  z.literal('ServiceNow'),
])

export const DatabusMessageDirectionSchema = z.union([
  z.literal('Inbound'),
  z.literal('Outbound'),
])

export const DatabusInboundProcessingStatusSchema = z.union([
  z.literal('received'),
  z.literal('processed_success'),
  z.literal('processed_failed'),
  z.literal('retried'),
  z.literal('discarded'),
])

export const DatabusOutboundStatusSchema = z.union([
  z.literal('pending'),
  z.literal('delivered'),
  z.literal('failed'),
])

export const DatabusMessageLogSchema = z.object({
  id: z.number(),
  source_system: DatabusSourceSystemSchema,
  message_direction: DatabusMessageDirectionSchema,
  entity: z.string(),
  entity_id: z.string(),
  action: z.string(),
  correlation_id: z.string(),
  inbound_processing_status: DatabusInboundProcessingStatusSchema.nullable(),
  outbound_status: DatabusOutboundStatusSchema.nullable(),
  error: z.string().nullable(),
  processed_at: z.string().nullable(),
  event_emitted_at: z.string().nullable(),
  created_at: z.string(),
})

export const DatabusMessageLogsResponseSchema = z.object({
  current_page: z.number(),
  data: z.array(DatabusMessageLogSchema),
  last_page: z.number(),
  per_page: z.number(),
  total: z.number(),
  from: z.number().nullable(),
  to: z.number().nullable(),
})

export type DatabusSourceSystem = z.infer<typeof DatabusSourceSystemSchema>
export type DatabusMessageDirection = z.infer<
  typeof DatabusMessageDirectionSchema
>
export type DatabusInboundProcessingStatus = z.infer<
  typeof DatabusInboundProcessingStatusSchema
>
export type DatabusOutboundStatus = z.infer<typeof DatabusOutboundStatusSchema>
export type DatabusProcessingStatus =
  | DatabusInboundProcessingStatus
  | DatabusOutboundStatus

export type DatabusMessageLog = z.infer<typeof DatabusMessageLogSchema>
export type DatabusMessageLogsResponse = z.infer<
  typeof DatabusMessageLogsResponseSchema
>
